import { useState } from "react";
import { Flame } from "lucide-react";
import { getStreak, setGoal } from "@/lib/streak";

const GOALS = [10, 20, 40];

export const StreakCard = () => {
  const [s, setS] = useState(getStreak());
  const pct = Math.min(s.today / s.goal, 1), r = 34, c = 2 * Math.PI * r;
  const change = (g) => { setGoal(g); setS(getStreak()); };
  return (
    <div data-testid="streak-card" className="flex flex-col gap-5 rounded-xl bg-white p-6 shadow-xl shadow-slate-950/30 sm:flex-row sm:items-center">
      <div className="relative h-24 w-24 shrink-0">
        <svg viewBox="0 0 80 80" className="h-24 w-24 -rotate-90"><circle cx="40" cy="40" r={r} fill="none" stroke="#e2e8f0" strokeWidth="8" />
          <circle cx="40" cy="40" r={r} fill="none" stroke={pct >= 1 ? "#10b981" : "#4f46e5"} strokeWidth="8" strokeLinecap="round" strokeDasharray={`${c * pct} ${c}`} /></svg>
        <div className="absolute inset-0 flex flex-col items-center justify-center"><span data-testid="streak-today" className="font-display text-xl font-extrabold text-slate-900">{s.today}</span><span className="font-mono text-[10px] text-slate-400">/ {s.goal}</span></div>
      </div>
      <div className="flex-1 space-y-2">
        <div className="flex items-center gap-2">
          <Flame className={`h-6 w-6 ${s.streak ? "text-orange-500" : "text-slate-300"}`} />
          <span data-testid="streak-count" className="font-display text-2xl font-extrabold text-slate-900">{s.streak} day{s.streak === 1 ? "" : "s"}</span>
          <span data-testid="streak-best" className="font-mono text-xs text-slate-400">best {s.best}</span>
        </div>
        <p data-testid="streak-status" className="text-sm text-slate-500">{s.today >= s.goal ? "Daily goal met — streak secured for today." : `Answer ${s.goal - s.today} more item${s.goal - s.today === 1 ? "" : "s"} today to ${s.streak ? "keep" : "start"} your streak.`}</p>
        <div className="flex gap-1.5" data-testid="streak-week">
          {s.week.map((d) => (
            <div key={d.key} title={`${d.key}: ${d.count}`} className="flex flex-col items-center gap-1">
              <span className={`h-6 w-6 rounded-md ${d.met ? "bg-emerald-500" : d.count ? "bg-indigo-200" : "bg-slate-100"}`} />
              <span className="font-mono text-[10px] text-slate-400">{d.label}</span>
            </div>
          ))}
        </div>
      </div>
      <div className="space-y-1">
        <div className="font-mono text-[10px] uppercase tracking-widest text-slate-400">Daily goal</div>
        <div className="flex gap-1">{GOALS.map((g) => <button key={g} data-testid={`streak-goal-${g}`} onClick={() => change(g)} className={`rounded-full px-3 py-1 font-mono text-xs font-semibold transition-colors ${s.goal === g ? "bg-indigo-600 text-white" : "bg-slate-100 text-slate-600 hover:bg-slate-200"}`}>{g}</button>)}</div>
      </div>
    </div>
  );
};
